import { call, put, takeLatest } from 'redux-saga/effects';
import { addContact } from '../api/contactApi';
import {
  CONTACT_SUBMIT_REQUEST,
  CONTACT_SUBMIT_SUCCESS,
  CONTACT_SUBMIT_FAILURE,
} from '../actions/contactActions';

function* submitContactSaga(action) {
  try {
    yield call(addContact, action.payload);
    yield put({ type: CONTACT_SUBMIT_SUCCESS });
  } catch (error) {
    const message =
      error.response?.status === 409
        ? error.response.data?.message
        : "Une erreur est survenue, veuillez réessayer.";
    yield put({ type: CONTACT_SUBMIT_FAILURE, payload: message });
  }
}

export default function* contactSaga() {
  yield takeLatest(CONTACT_SUBMIT_REQUEST, submitContactSaga);
}
